import styled from 'styled-components';

import DateInput from '../../../../shared/DateInput';
import useDateInput from '../../../../shared/DateInput/useDateInput';
import { Wrapper, Title } from '../../../../shared/ModalComponents';
import { Button } from '../../../../shared/FormStyles/Button';

const ButtonGroup = styled.div`
  padding: 8px 8px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const CampaignDates = ({ onCancel, initialDates, onSave, title, size = 1 }) => {
  const {
    startInputValue,
    endInputValue,
    activeFilter,
    onFilterChange,
    dates,
    isValid,
    onDateChange,
    onInputChange,
  } = useDateInput({ initialDates });
  const inputValue = `${startInputValue} - ${endInputValue}`;
  return (
    <Wrapper>
      <Title style={{ padding: '0 11px' }}>{title}</Title>
      <DateInput
        startInputValue={startInputValue}
        endInputValue={endInputValue}
        activeFilter={activeFilter}
        dates={dates}
        isValid={isValid}
        onDateChange={onDateChange}
        onInputChange={onInputChange}
        onFilterChange={onFilterChange}
        size={size}
      />
      <ButtonGroup>
        <Button variant="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="containedBlue"
          ml="8px"
          disabled={!isValid}
          onClick={() => onSave(dates, inputValue)}
        >
          Save
        </Button>
      </ButtonGroup>
    </Wrapper>
  );
};

export default CampaignDates;
